import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import { Award, CheckCircle, Shield, Globe } from 'lucide-react';

const CertificationsPage = () => {
  const certifications = [
    {
      icon: Award,
      name: 'ISO 9001:2015',
      description: 'Quality Management System',
      details: 'Certified for maintaining consistent quality standards in manufacturing and supply'
    },
    {
      icon: Shield,
      name: 'ISO 14001:2015',
      description: 'Environmental Management',
      details: 'Committed to environmentally responsible manufacturing practices'
    },
    {
      icon: Globe,
      name: 'CE Marking',
      description: 'European Conformity',
      details: 'Products meet EU safety, health, and environmental protection standards'
    }
  ];

  const qualityStandards = [
    'RMA (Rubber Manufacturers Association) Standards',
    'DIN (German Institute for Standardization)',
    'ASTM International Standards',
    'BIS (Bureau of Indian Standards)',
    'ISO Standards for Belt Testing',
    'Custom specifications as per client requirements'
  ];

  return (
    <div className="min-h-screen">
      <Navigation />
      
      <div className="pt-32 pb-20 px-6 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="mb-12 text-center">
            <h1 className="heading-font text-4xl text-[#1E293B] mb-4" data-testid="certifications-title">
              CERTIFICATIONS & STANDARDS
            </h1>
            <p className="text-[#64748B] text-base max-w-2xl mx-auto">
              Committed to quality, safety, and international standards
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
            {certifications.map((cert, index) => {
              const Icon = cert.icon;
              return (
                <div key={index} className="glass-card p-8 text-center card-hover" data-testid={`certification-${index}`}>
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-[#3B82F6]/10 border border-[#3B82F6]/20 mb-6">
                    <Icon className="text-[#3B82F6]" size={32} />
                  </div>
                  <h2 className="heading-font text-xl text-[#1E293B] mb-2">{cert.name}</h2>
                  <div className="text-[#3B82F6] text-sm mb-4">{cert.description}</div>
                  <p className="text-[#64748B] text-sm">{cert.details}</p>
                </div>
              );
            })}
          </div>

          <div className="glass-card p-8">
            <h2 className="heading-font text-2xl text-[#1E293B] mb-6">QUALITY STANDARDS</h2>
            <p className="text-[#64748B] mb-6">
              Our products are manufactured and tested according to internationally recognized standards:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {qualityStandards.map((standard, index) => (
                <div key={index} className="flex items-start space-x-3" data-testid={`standard-${index}`}>
                  <CheckCircle size={20} className="text-[#3B82F6] mt-0.5 flex-shrink-0" />
                  <span className="text-[#64748B] text-sm">{standard}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-12 metal-gradient p-12">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
              <div>
                <h2 className="heading-font text-3xl text-[#1E293B] mb-4">70+ YEARS OF EXCELLENCE</h2>
                <p className="text-[#64748B] mb-6">
                  Since 1951, SIMPSON & MUNRO has been synonymous with quality and reliability in the power transmission industry.
                  Our commitment to excellence is backed by rigorous testing and quality control processes.
                </p>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-white/50 p-6 border border-white/5">
                  <div className="text-3xl font-bold text-[#3B82F6] mb-2">70+</div>
                  <div className="text-[#64748B] text-sm">Years in Business</div>
                </div>
                <div className="bg-white/50 p-6 border border-white/5">
                  <div className="text-3xl font-bold text-[#3B82F6] mb-2">1000+</div>
                  <div className="text-[#64748B] text-sm">Satisfied Clients</div>
                </div>
                <div className="bg-white/50 p-6 border border-white/5">
                  <div className="text-3xl font-bold text-[#3B82F6] mb-2">50+</div>
                  <div className="text-[#64748B] text-sm">Industries Served</div>
                </div>
                <div className="bg-white/50 p-6 border border-white/5">
                  <div className="text-3xl font-bold text-[#3B82F6] mb-2">100%</div>
                  <div className="text-[#64748B] text-sm">Quality Assured</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default CertificationsPage;